import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import VisualMap from "./pages/VisualMap";
import TypesOfCaregivers from "./pages/TypesOfCaregivers";
import TabsPage from "./pages/TabsPage";
import GenderZoomIn from "./components/ZoomInModels/GenderZoomIn";
import CareEconomyZoomIn from "./components/ZoomInModels/CareEconomyZoomIn";
import MentalHealthZoomIn from "./components/ZoomInModels/MentalHealthZoomIn";
import ClimateChangeZoomIn from "./components/ZoomInModels/ClimateChangeZoomIn";
import TrendsZoomIn from "./components/ZoomInModels/TrendsZoomIn";
import TypesOfCaregiversZoomIn from "./components/ZoomInModels/TypesOfCaregiversZoomIn";
import Loader from "./components/ui/Loader";

const AppContent = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  // Handle route changes and page loads
  useEffect(() => {
    setIsLoading(true);

    // Wait for page to be fully loaded
    const handlePageLoad = () => {
      // Small delay to ensure all content is rendered
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    };

    // Check if page is already loaded
    if (document.readyState === "complete") {
      handlePageLoad();
    } else {
      window.addEventListener("load", handlePageLoad);
      // Also check after a short delay in case load event already fired
      const timer = setTimeout(handlePageLoad, 100);
      return () => {
        window.removeEventListener("load", handlePageLoad);
        clearTimeout(timer);
      };
    }
  }, [location.pathname]);

  // Handle initial page load
  useEffect(() => {
    if (document.readyState === "complete") {
      setIsLoading(false);
    } else {
      const handleInitialLoad = () => {
        setTimeout(() => {
          setIsLoading(false);
        }, 300);
      };
      window.addEventListener("load", handleInitialLoad);
      return () => window.removeEventListener("load", handleInitialLoad);
    }
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      <Routes>
        <Route path="/" element={<VisualMap />} />
        <Route path="/types-of-caregivers" element={<TypesOfCaregivers />} />
        <Route path="/tabs" element={<TabsPage />} />
        <Route path="/zoom-in-gender" element={<GenderZoomIn />} />
        <Route path="/zoom-in-care-economy" element={<CareEconomyZoomIn />} />
        <Route path="/zoom-in-mental-health" element={<MentalHealthZoomIn />} />
        <Route
          path="/zoom-in-climate-change"
          element={<ClimateChangeZoomIn />}
        />
        <Route path="/zoom-in-trends" element={<TrendsZoomIn />} />
        <Route
          path="/zoom-in-types-of-caregivers"
          element={<TypesOfCaregiversZoomIn />}
        />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
